import { useSyncExternalStore } from "react";
import { Navigate } from "react-router-dom";

import {
  getAuthSessionSnapshot,
  subscribeAuthSession,
} from "@/lib/auth/session";
import { useSandboxCredentialsEnabled } from "@/lib/feature-flags/useSandboxCredentialsEnabled";
import { GLOFOX_DOCS_HOME_ROUTE } from "@/lib/portal/docs-urls";
import DeveloperPortalPage from "@/pages/glofox/DeveloperPortalPage";
import LoginPage from "@/pages/LoginPage";

export default function HomePage() {
  const sandboxCredentialsEnabled = useSandboxCredentialsEnabled();
  const session = useSyncExternalStore(
    subscribeAuthSession,
    getAuthSessionSnapshot,
    getAuthSessionSnapshot,
  );

  if (!session) {
    return <LoginPage />;
  }

  // Legacy (flag off): send authenticated users to docs instead of Slice 6 home.
  if (!sandboxCredentialsEnabled) {
    return <Navigate to={GLOFOX_DOCS_HOME_ROUTE} replace />;
  }

  return <DeveloperPortalPage session={session} />;
}
